import type { TFunction } from "i18next";

import type { IButtonVariantsData } from "@components/atoms/button";
import { Icon } from "@components/atoms/icons";

export const VButtonVariants = (t: TFunction<"form">): IButtonVariantsData => ({
  default: {},
  main: { color: "secondary" },
  secondary: { color: "primary", variant: "outlined" },
  "danger-main": { color: "danger", variant: "outlined" },
  "danger-secondary": { color: "danger" },
  cancel: {
    color: "danger",
    variant: "outlined",
    type: "button",
  },
  submit: {
    color: "secondary",
    type: "submit",
  },
  action: { variant: "transparent" },
  add: {
    variant: "transparent",
    type: "button",
    label: t("addToList"),
    icon: <Icon name={"AddSquare"} />,
  },
  select: { variant: "transparent", type: "button", label: "Select" },
  "edit-add": {
    variant: "contained",
    color: "secondary",
    label: t("submit_and_add"),
    icon: <Icon name={"PenNewSquare"} />,
  },
});
